import {useEffect} from 'react';
import {getType} from 'typesafe-actions';
import {Interpreter} from 'xstate';
import {CLOSE_BUTTONS_CONSTANT} from '../../components/Page/CloseButtonsConstant';
import {GET_CONTAINER_DISPLAY_M} from '../../machines/getContainerDisplay';
import {TMeta} from '../../machines/appMachine/AppContext';
import {mergeMetadata} from '../../machines/utils/mergeMeta';
import {backButtonAction, closeAction} from '../../store/actions';

function hasBackActions(state) {
  return state.nextEvents.includes(getType(backButtonAction));
}

function hasActions(state, action) {
  return state.nextEvents.includes(getType(action));
}

function isLoading(state) {
  return mergeMetadata<TMeta>(state.meta).show !== GET_CONTAINER_DISPLAY_M.LOADING;
}

const ENABLED = location.hash.startsWith('#/get');

export function useHistory(service: Interpreter<unknown>) {
  useEffect(() => {
    if (!ENABLED) {
      return;
    }
    const handlePopState = () => {
      if (hasBackActions(service.state)) {
        service.send(backButtonAction());
      } else if (hasActions(service.state, closeAction)) {
        service.send(closeAction(CLOSE_BUTTONS_CONSTANT.HISTORY));
        return;
      }
    };
    let previousStateValue;
    const stateChangeHandler = (state, event) => {
      const stateValue = state.toStrings().pop() || 'initial';
      if (event.type === getType(backButtonAction)) {
        return;
      }
      if (hasBackActions(state) && stateValue !== previousStateValue && isLoading(state)) {
        previousStateValue = stateValue;
        history.pushState({type: stateValue}, stateValue);
      }
    };

    window.addEventListener('popstate', handlePopState);
    service.onTransition(stateChangeHandler);

    history.pushState({type: 'init'}, 'init');
    return () => {
      service.off(stateChangeHandler);
      window.removeEventListener('popstate', handlePopState);
    };
  }, [service]);
}
